import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function displaySwitchOption(theme: Theme): ComponentStyle {
  return {
    componentName: 'displaySwitchOption',
    baseStyle: {
      padding: `${theme.space['2xs']} ${theme.space['s']}`,
      fontSize: theme.sizes['-1'],
      fontWeight: 600,
      color: theme.colors.hype.textSecondary,
      borderRadius: '9999px',

      ['&:hover']: {
        backgroundColor: theme.colors.hype.textSecondary,
        color: theme.colors.hype.background70
      }
    },
    states: {
      active: {
        backgroundColor: theme.colors.primary,
        color: theme.colors.hype.background70,

        ['&:hover']: {
          backgroundColor: theme.colors.primary
        }
      }
    }
  };
}
